{
  "Accessibility Menu": "ప్రాప్యత మెనూ",
  "Reset settings": "సెట్టింగ్‌లను రీసెట్ చేయండి",
  "Close": "మూసివేయి",
  "Content Adjustments": "కంటెంట్ సర్దుబాట్లు",
  "Adjust Font Size": "ఫాంట్ పరిమాణాన్ని సర్దుబాటు చేయండి",
  "Highlight Title": "శీర్షికను హైలైట్ చేయండి",
  "Highlight Links": "లింక్‌లను హైలైట్ చేయండి",
  "Readable Font": "చదవడానికి అనుకూలమైన ఫాంట్",
  "Color Adjustments": "రంగు సర్దుబాట్లు",
  "Dark Contrast": "చీకటి వ్యత్యాసం",
  "Light Contrast": "తెల్లటి వ్యత్యాసం",
  "High Contrast": "అధిక వ్యత్యాసం",
  "High Saturation": "అధిక సంతృప్తి",
  "Low Saturation": "తక్కువ సంతృప్తి",
  "Monochrome": "మోనోక్రోమ్",
  "Contrast": "కాంట్రాస్ట్",
  "Invert Colors": "రంగులను తారుమారు చేయండి",
  "Tools": "పరికరాలు",
  "Reading Guide": "చదవడం మార్గదర్శకుడు",
  "Stop Animations": "యానిమేషన్‌లను ఆపు",
  "Big Cursor": "పెద్ద కర్సర్",
  "Increase Font Size": "ఫాంట్ పరిమాణాన్ని పెంచండి",
  "Decrease Font Size": "ఫాంట్ పరిమాణాన్ని తగ్గించండి",
  "Letter Spacing": "అక్షరాల మధ్య ఖాళీ",
  "Line Height": "లైన్ ఎత్తు",
  "Font Weight": "ఫాంట్ బరువు",
  "Dyslexia Font": "డిస్లెక్సియా ఫాంట్",
  "Language": "భాష",
  "Open Accessibility Menu": "ప్రాప్యత మెనూను తెరవండి",
  "Widget Settings": "విడ్జెట్ సెట్టింగులు",
  "Widget Position": "విడ్జెట్ స్థానము",
  "Top Left": "పై ఎడమ",
  "Top Center": "పై మధ్య",
  "Top Right": "పై కుడి",
  "Center Left": "మధ్య ఎడమ",
  "Center Right": "మధ్య కుడి",
  "Bottom Left": "క్రింద ఎడమ",
  "Bottom Center": "క్రింద మధ్య",
  "Bottom Right": "క్రింద కుడి",
  "Screen Reader": "స్క్రీన్ రీడర్",
  "Voice Navigation": "వాయిస్ నావిగేషన్",
  "Custom Color": "అనుకూల రంగు",
  "Change the site's colors": "సైట్ రంగులను మార్చండి",
  "Backgrounds": "నేపథ్యాలు",
  "Headings": "శీర్షికలు",
  "Contents": "కంటెంట్",
  "Reset colors": "రంగులను రీసెట్ చేయండి",
  "Image Desaturation": "చిత్ర రంగు తగ్గింపు",
  "Search languages": "భాషలను శోధించండి",
  "No languages found": "ఏ భాషలు కనబడలేదు",
  "Accessibility Profiles": "అందుబాటు ప్రొఫైళ్లు",
  "Motor Impaired": "మోటార్ లోపం",
  "Big cursor, voice navigation, and no animations.": "పెద్ద కర్సర్, వాయిస్ నావిగేషన్ మరియు యానిమేషన్ లేదు.",
  "Blind": "దృష్టి లోపం",
  "Screen reader helpers with higher contrast.": "అధిక కాంట్రాస్ట్‌తో స్క్రీన్ రీడర్ సహాయకులు.",
  "Color Blind": "రంగు చీమటేమి",
  "High contrast palette with desaturated media.": "అధిక వ్యత్యాస ప్యాలెట్ మరియు తక్కువ రంగు మీడియా.",
  "Dyslexia": "డిస్లెక్సియా",
  "Friendly font, extra spacing, stronger weight.": "సులభంగా చదవగల అక్షరరూపం, అదనపు స్పేసింగ్ మరియు మందమైన అక్షరాలు.",
  "Low vision": "తక్కువ చూపు",
  "Dark contrast and 130% magnification.": "గాఢమైన వ్యత్యాసం మరియు 130% పెంపు.",
  "Cognitive & Learning": "జ్ఞాన మరియు అభ్యాసం",
  "Highlights key sections and enables voice help.": "కీలక విభాగాలను హైలైట్ చేసి వాయిస్ సహాయాన్ని ప్రారంభిస్తుంది.",
  "Seizure & Epileptic": "నవ్వు మరియు ఎపిలెప్సి",
  "Stops animations and desaturates imagery.": "అనిమేషన్‌లను ఆపి చిత్రాలలో రంగును తగ్గిస్తుంది.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "చదవడానికి మార్గదర్శి, హైలైట్ చేసిన లింకులు మరియు శాంతమైన రంగుల సెట్.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
